var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('div',[_c('div',{staticClass:"loginLeftName"},[_c('img',{attrs:{"src":require("../assets/radianceImage.png"),"alt":"picture"}})])])])
}]

export { render, staticRenderFns }